export const LANDING_SCREEN_VARIANTS = {
	PROTECT: "protect",
	VERIFY: "verify",
};



// WEBPACK FOOTER //
// ./src/shared/components/SmsMigrationModal/constants.js